module.exports = __webpack_public_path__ + "static/media/street.bd1b04ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/street.gif
// module id = 864
// module chunks = 0